import { alpha, Stack, styled } from '@mui/material';

export const StyledLeftSideHeader = styled('header')(({ theme: { palette, spacing } }) => ({
  display: 'flex',
  position: 'sticky',
  width: '100%',
  height: spacing(12),
  marginTop: spacing(1),
  color: palette.cvi.neutrals[10],
  alignItems: 'center',
  justifyContent: 'center',
  overflow: 'hidden',
  '& svg': {
    position: 'absolute',
    top: spacing(-6.25),
    left: 0,
    width: spacing(79.6),
    zIndex: -1,
  },
}));

export const StyledLeftSideWrapper = styled(Stack)(({ theme: { palette, spacing } }) => ({
  background: palette.cvi.primary[30],
  width: spacing(40),
  height: '100%',
  color: palette.cvi.neutrals[10],
  justifyContent: 'space-between',
  alignItems: 'center',
  position: 'relative',
}));

export const StyledMobileHeader = styled(Stack)(({ theme: { palette, spacing } }) => ({
  background: palette.cvi.primary[30],
  width: '100vw',
  padding: spacing(3, 2),
  color: palette.cvi.neutrals[10],
  justifyContent: 'space-between',
  alignItems: 'center',
  flexDirection: 'row',
}));

export const StyledMenuContent = styled(Stack)(({ theme: { spacing, breakpoints } }) => ({
  gap: spacing(2),
  padding: spacing(0, 2),
  overflowY: 'auto',
  marginBottom: spacing(10),
  scrollbarWidth: 'none',
  '&::-webkit-scrollbar': {
    display: 'none',
  },
  [breakpoints.up('md')]: {
    width: spacing(40),
    height: '100%',
    padding: spacing(6, 0, 0, 3),
  },
}));

export const StyledMenuFooter = styled(Stack)(({ theme: { palette, spacing } }) => ({
  backgroundColor: alpha(palette.cvi.primary[30], 0.85),
  backdropFilter: `blur(${spacing(0.5)})`,
  gap: spacing(1),
  alignItems: 'center',
  justifyContent: 'center',
  padding: spacing(1, 0, 3),
  position: 'absolute',
  bottom: 0,
  width: '100%',
  zIndex: 10,
}));

export const StyledMobileMenu = styled(Stack)(({ theme: { spacing, palette } }) => ({
  maxWidth: spacing(40),
  height: '100%',
  backgroundColor: palette.cvi.primary[30],
  gap: spacing(4),
}));

export const StyledMobileMenuHeader = styled('header')(({ theme: { spacing } }) => ({
  padding: spacing(4.3, 2, 0.5),
  display: 'flex',
  justifyContent: 'flex-end',
}));
